import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper
} from '@mui/material';
import { styled } from '@mui/system';

// Konfiguracja czterech tabel
const tableData = [
 
  {
    label: 'Zestawienie elementów żelbetowych',
    columns: ['Grubość (cm)', 'Długość (m)', 'Liczba (szt.)', 'Objętość (m3)'],
    rows: [
      { thickness: '24', length: '24', count: '6', volume: '26,8' },
    ],
  },
  {
    label: 'Zestawienie drzwi',
    columns: ['Typ drzwi', 'Szerokość (cm)', 'Wysokość (cm)', 'Liczba'],
    rows: [
      { type: 'D1', width: '100', height: '223', count: '2' },
      { type: 'D2', width: '240', height: '213', count: '4' },
      { type: 'DG', width: '245', height: '213', count: '1' },
    ],
  },
   {
    label: 'Zestawienie ścian murowanych',
    columns: ['Grubość (cm)', 'Powierzchnia (m2)', 'Objętość (m3)'],
    rows: [
      { thickness: '24', area: '111,7', volume: '26,8' },
      { thickness: '12', area: '21,5', volume: '2,6' },
    ],
  },
  {
    label: 'Zestawienie okien',
    columns: ['Typ okna', 'Szerokość (cm)', 'Wysokość (cm)', 'Liczba'],
    rows: [
      { type: '01', width: '50', height: '110', count: '1' },
      { type: '02', width: '150', height: '130', count: '7' },
    ],
  },
];

// Wrapper sekcji
const SectionWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  paddingTop: 0,
  paddingBottom: '120px',
}));

// Nagłówek z podkreśleniem
const UnderlinedHeading = styled('span')({
  position: 'relative',
  zIndex: 1,
  display: 'inline-block',
  '&::after': {
    content: '""',
    position: 'absolute',
    zIndex: -1,
    right: 0,
    bottom: 0,
    width: '30%',
    height: '30px',
    backgroundImage: 'url(/img/redunderline.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'bottom center',
  },
});

const Section3 = () => {
  const downloadLinks = {
    'Pobierz raport': '/bimetria_raport.pdf',
    'Pobierz model IFC': '/bimetria_model.ifc',
    'Pobierz zestawienia': '/bimetria_zestawienia.zip',
  };

  return (
    <SectionWrapper component="section" position="relative">
      <Container maxWidth="xl" fixed>
        <Box
          component="img"
          src="/img/bgpicture2.png"
          alt="bg watermark"
          sx={{
            position: 'absolute',
            left: 0,
            top: '-5%',
            width: { xs: '100%', md: '48%' },
            zIndex: 0,
          }}
        />

        {/* Tytuły */}
        <Typography
          variant="h2"
          align="center"
          sx={{ fontSize: { xs: '28px', lg: '42px', xl: '42px' }, fontWeight: 'bold', color: 'primary.main', mb: 4, position: 'relative', zIndex: 1 }}
        >
          <UnderlinedHeading>Pobierz przykładowy raport</UnderlinedHeading>
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            fontSize: { xs: '18px', md: '24px' },
            color: 'text.primary',
            maxWidth: '100%',
            mx: 'auto',
            mb: 4,
            position: 'relative',
            zIndex: 1,
          }}
        >
W wyniku działania aplikacji otrzymasz raport PDF, model IFC oraz zestawienia XLSX.
Jeśli chcesz się dowiedzieć czego możesz się spodziewać, sprawdź demonstracyjne wyniki, które dla Ciebie przygotowaliśmy.
        </Typography>
        <Typography
          variant="h3"
          align="center"
          sx={{ fontSize: '26px', fontWeight: 'bold', color: 'primary.main', mb: 6, position: 'relative', zIndex: 1 }}
        >
          Projekt: Malinowa 10
        </Typography>

        <Grid container spacing={4}>
          {/* Lewa część: pierwsze 2 tabele */}
          <Grid item size={{ xs: 12, md: 6 }} sx={{ position: 'relative', zIndex: 1 }}>
            <Grid container spacing={4}>
              {tableData.slice(0, 2).map(({ label, columns, rows }, idx) => (
                <Grid item size={{ xs: 12, sm: 6 }} key={idx} sx={{ width: { xs: '100%', sm: '90%' } }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>{label}</Typography>
                  <TableContainer component={Paper} elevation={0} sx={{ width: '100%' }}>
                    <Table size="small" sx={{ width: '100%' }}>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: 'rgba(6,79,151,0.33)' }}>
                          {columns.map(col => <TableCell key={col} sx={{ fontWeight: 'bold', color: 'primary.main', py: 1 }}>{col}</TableCell>)}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row, ri) => (
                          <TableRow key={ri}>
                            {Object.values(row).map((value, ci) => <TableCell key={ci} sx={{ py: 1 }}>{value}</TableCell>)}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Prawa część: kolejne 2 tabele i obrazek */}
          <Grid item size={{ xs: 12, md: 6 }} sx={{ position: 'relative', zIndex: 1 }}>
            <Grid container spacing={4}>
              {tableData.slice(2).map(({ label, columns, rows }, idx) => (
                <Grid item size={{ xs: 12, sm: 6 }} key={idx} sx={{ width: { xs: '100%', sm: '90%' } }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>{label}</Typography>
                  <TableContainer component={Paper} elevation={0} sx={{ width: '100%' }}>
                    <Table size="small" sx={{ width: '100%' }}>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: 'rgba(6,79,151,0.33)' }}>
                          {columns.map(col => <TableCell key={col} sx={{ fontWeight: 'bold', color: 'primary.main', py: 1 }}>{col}</TableCell>)}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row, ri) => (
                          <TableRow key={ri}>
                            {Object.values(row).map((value, ci) => <TableCell key={ci} sx={{ py: 1 }}>{value}</TableCell>)}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              ))}

              {/* Obrazek pod tabelami */}
              {/* <Grid item size={{ xs: 12 }}>
                <Box
                  component="img"
                  src="/img/raport.png"
                  alt="Przykładowy raport"
                  sx={{ width: '100%', height: 'auto' }}
                />
              </Grid> */}
            </Grid>
          </Grid>
        </Grid>

      {/* Przyciski pod sekcją */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '30px', mt: 16, flexWrap: { xs: 'wrap', md: 'nowrap' }, position: 'relative', zIndex: 1 }}>
          {Object.keys(downloadLinks).map((label, i) => (
            <Button
              download
              key={i}
              component="a"
              href={downloadLinks[label]}
              rel="noopener noreferrer"
              variant="contained"
              sx={{ backgroundColor: 'turquoise.main', color: 'white', textTransform: 'none', fontWeight: 500, fontSize: '20px', '&:hover': { backgroundColor: 'turquoise.dark' }, width: { xs: '100%', md: 'auto' } }}
            >
              {label}
            </Button>
          ))}
        </Box>
      </Container>
    </SectionWrapper>
  );
};

export default Section3;
